export const shortAddress = (address: string): string => {
  if (address.length <= 9) {
    return address;
  }
  return `${address.substring(0, 9)}...`;
};
